module.exports = __webpack_public_path__ + "static/media/bell-regular.c1bedbfe.svg";